import { defaults } from 'react-chartjs-2';
import { colors, fonts } from 'Shared/util/theme';


const common = () => {
  defaults.global = {
    ...defaults.global,
    defaultFontFamily: fonts.main,
    defaultFontSize: 14,
    defaultFontColor: 'rgba(0,0,0,1)',
    defaultColor: colors.main,
    animation: {
      ...defaults.global.animation,
      duration: 1500,
    },
    tooltips: {
      ...defaults.global.tooltips,
      displayColors: false,
    },
    legend: {
      ...defaults.global.legend,
      onClick: null,
      labels: {
        ...defaults.global.legend.labels,
        usePointStyle: true,
      },
    },
  };
};

const bar = () => {
  defaults.bar = {
    ...defaults.bar,
    legend: {
      ...defaults.bar.legend,
      display: false,
    },
    scales: {
      ...defaults.bar.scales,
      xAxes: [{
        ...defaults.bar.scales.xAxes[0],
        gridLines: {
          ...defaults.bar.scales.xAxes[0].gridLines,
          display: false,
        },
      }],
      yAxes: [{
        ...defaults.bar.scales.yAxes[0],
        ticks: {
          ...defaults.bar.scales.yAxes[0].ticks,
          beginAtZero: true,
        },
      }],
    },
  };
};

const pie = () => {
  defaults.pie = {
    ...defaults.pie,
    legend: {
      ...defaults.pie.legend,
      display: false,
    },
  };
};


export const setChartDefaults = () => {
  common();
  bar();
  pie();
};
